import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'antd';

import { Default } from '../../../../layouts';

import useDatasource from '../../../../hooks/useDatasource';
import {
  deleteStationType,
  getStationTypes,
} from '../../../../services/taxonomies/station-types';

import PageTitle from '../../../../components/PageTitle';
import AddEntityButton from '../../../../components/buttons/AddEntityButton';
import EditItemIcon from '../../../../components/buttons/EditItemIcon';
import DeleteItemIcon from '../../../../components/buttons/DeleteItemIcon';
import Column from '../../../../helpers/columns';
import ViewItemIcon from '../../../../components/buttons/ViewItemIcon';
import usePermissions from '../../../../hooks/usePermission';

const permissionsMap = {
  canView: ['ADMINISTRATION_TAXONOMIES_VIEW_PERMISSION'],
  canEdit: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
  canDelete: ['SYS_SUPERUSER', 'TAXONOMIES_PERMISSION'],
};

const StationTypesList = () => {
  const { t } = useTranslation();
  const { canView, canEdit, canDelete } = usePermissions(permissionsMap);
  const { pagination, content, handleChange, reload } =
    useDatasource(getStationTypes);

  const columns = useMemo(
    () => [
      Column.text('name', t('entity.taxonomy.stationType.name'), {
        filter: true,
      }),
      Column.bool('deleted', t('entity.taxonomy.stationType.deleted._'), {
        width: 150,
        filter: true,
        inverted: true,
        labels: [
          t('table.filter.all'),
          t('entity.taxonomy.stationType.deleted.true'),
          t('entity.taxonomy.stationType.deleted.false'),
          t('table.filter.unknown'),
        ],
      }),
      Column.actions(t('table.actions'), (record) => (
        <>
          {canView && (
            <ViewItemIcon
              path={`/admin/taxonomies/station-types/${record.id}`}
            />
          )}
          {canEdit && (
            <EditItemIcon
              path={`/admin/taxonomies/station-types/${record.id}`}
            />
          )}
          {canDelete && (
            <DeleteItemIcon
              title={t('entity.taxonomy.stationType._delete', record)}
              message={t('entity.taxonomy.stationType._deleted', record)}
              item={record}
              action={deleteStationType}
              reload={reload}
            />
          )}
        </>
      )),
    ],
    [t, canView, canEdit, canDelete, reload],
  );

  return (
    <Default>
      <PageTitle title={t('entity.taxonomy.stationType._plural')}>
        {canEdit && (
          <AddEntityButton
            entity={t('entity.taxonomy.stationType._singular')}
            path="/admin/taxonomies/station-types/new"
          />
        )}
      </PageTitle>
      <Table
        columns={columns}
        rowKey="name"
        // loading={loading}
        pagination={pagination}
        dataSource={content}
        onChange={handleChange}
        scroll={{ x: 700, y: 700 }}
      />
    </Default>
  );
};

export default StationTypesList;
